import { Helmet } from "react-helmet";
import NewHead from "../../landing/NewHead";
import "./Launchpad.css";
import ServiceFooter from "../../ServiceFooter";
import {
  bestFeatures,
  featureData,
  launchpadData,
  processData,
  whyChooseData,
} from "./data";
import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const Launchpad = () => {
  // blockchains
  const [isPrevBlockDisabled, setIsPrevBlockDisabled] = useState(true);
  const [isNextBlockDisabled, setIsNextBlockDisabled] = useState(false);

  const handleBlockChange = (BlockSwiper) => {
    setIsPrevBlockDisabled(BlockSwiper.isBeginning);
    setIsNextBlockDisabled(BlockSwiper.isEnd);
  };
  return (
    <>
      <NewHead />

      <Helmet>
        <title>Crypto Launchpad Development Company</title>

        <meta name="title" content=" Crypto Launchpad Development Company" />
        <meta
          name="description"
          content="Acquire crypto launchpad development Services to gain better visibility and investor traction. Cryptocurrency launchpad development helps to boost different crypto projects by allowing them to raise funds. Beleaf holds expertise in IDO launchpad development as per your requirements."
        />
        <meta
          property="og:title"
          content=" Crypto Launchpad Development Company"
        />
        <meta property="og:site_name" content="Beleaf Technologies" />

        <link
          rel="canonical"
          href="https://www.beleaftechnologies.com/crypto-launchpad-development-company"
        />
      </Helmet>

      <main className="lnpd_main">
        {/* hero */}
        <article className="lnpd_hero lnpd_mb_80">
          <div className="primary__landing-content-container">
            <h1 className="lnpd_title">
              {" "}
              <span className="lnpd_span"> Crypto Launchpad</span> Development
              Company
            </h1>
            <p className="lnpd_content">
              Elevate the Drapes on Your Crypto Launchpad With Our White-Label
              Launchpad Development Services!!!
            </p>

            <div className="lnpd_hero_img_wrap">
              <img
                // src="https://res.cloudinary.com/dmjw7pe6k/image/upload/v1750062704/hero_n7n3yk.webp"
                src="https://res.cloudinary.com/djcn5wxkj/image/upload/v1777113999/hero_two_l0cocd_1_1_f5hqrv.webp"
                alt="Crypto Launchpad Development Company"
                loading="lazy"
                className="lnpd_hero_roc"
              />
              <img
                src="https://res.cloudinary.com/djcn5wxkj/image/upload/v1777114041/hero_coins_khphxv_1_1_uvp1eg.webp"
                alt="Crypto Launchpad Development Company"
                loading="lazy"
                className="lnpd_hero_coins"
              />
            </div>
          </div>
        </article>

        {/* journey */}
        <article className="primary__landing-content-container">
          <div className="lnpd_journey lnpd_mb_100">
            <div className="row g-4">
              <div className="col-lg-5">
                <h3 className="lnpd_jr_title">
                  <span className="lnpd_span">Accelerate </span>
                  your Cryptocurrency Launchpad Development Journey
                </h3>
                <button
                  data-toggle="modal"
                  data-target="#myModal"
                  className="lnpd_btn mt-2"
                >
                  Get a Demo
                </button>
              </div>
              <div className="col-lg-7">
                <p className="lnpd_jr_cnt">
                  A cryptocurrency launchpad is one such innovation that has
                  simplified the fundraising paradigm. Build in The crypto
                  industry is growing exponentially, with over 1 billion people
                  across the globe g a crypto launchpad means unlocking new
                  revenue streams.
                </p>
                <p className="lnpd_jr_cnt">
                  Beleaf provides complete crypto launchpad development services
                  to assist you in building your launchpad and capitalising on
                  the revenue-generation opportunities. Our experienced
                  blockchain engineers and subject matter experts shorten your
                  time-to-market and assist you in taking the lead. Use our
                  skills to create your crypto launchpad.
                </p>
              </div>
            </div>
          </div>
        </article>

        {/* white label */}
        <article className="primary__landing-content-container">
          <div className="lnpd_wt_lbl lnpd_mb_100">
            <div className="row g-4 lnpd_wt_row">
              <div className="col-lg-5 text-center">
                <img
                  src="https://res.cloudinary.com/djcn5wxkj/image/upload/v1777114847/white_label_an4j2g_1_1_b4vr3h.webp"
                  alt="Crypto Launchpad Development Company"
                  loading="lazy"
                  className="lnpd_wt_lbl_img"
                />
              </div>
              <div className="col-lg-7">
                <h3 className="lnpd_subtitle">
                  <span className="lnpd_span">White label </span>
                  Crypto Launchpad Development
                </h3>
                <p className="lnpd_subcontent">
                  Beleaf technology ensures the unrestricted launch of numerous
                  coins and provide White label Launchpad Development Services
                  with more sustainability and transparency. With our White
                  label Launchpad development services, we assist startups and
                  small businesses establish their bitcoin launchpad platform
                  according to your specifications. We provide investors with
                  24-hour access to extra cash, as well as speedy liquidity and
                  high flexibility.
                </p>
                <button
                  data-toggle="modal"
                  data-target="#myModal"
                  className="lnpd_btn mt-2"
                >
                  Get a Quote Now
                </button>
              </div>
            </div>
          </div>
        </article>

        {/* box */}
        <article className="primary__landing-content-container">
          <div className="lnpd_box lnpd_box_flx lnpd_mb_100">
            <p className="lnpd_box_cnt">
              Acquire Future Crypto Projects That Need To Raise Money With Our
              Launchpad Development Services!!
            </p>
            <button
              data-toggle="modal"
              data-target="#myModal"
              className="lnpd_box_btn "
            >
              Get Free Consultancy{" "}
              <span>
                <i className="fa-solid fa-arrow-right"></i>
              </span>
            </button>
          </div>
        </article>

        {/* models */}
        <article className="lnpd_models lnpd_mb_100">
          <div className="primary__landing-content-container">
            <div className="row mx-0 g-4">
              <div className="col-lg-6">
                <h3 className="lnpd_subtitle">
                  Our Crypto Launchpad{" "}
                  <span className="lnpd_span"> Fundraising Models</span>
                </h3>
                <p className="lnpd_subcontent">
                  We offer a wide range of services to meet the demands of
                  various businesses
                </p>
              </div>
              <div className="col-lg-6">
                <div className="lnpd_models_wrap">
                  {launchpadData.map((item, index) => (
                    <div className="lnpd_models_flx" key={index}>
                      <h5>{item.title}</h5>
                      <p>{item.description}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </article>

        {/* box */}
        <article className="primary__landing-content-container">
          <div className="lnpd_box lnpd_bx_bst lnpd_mb_100">
            <p className="lnpd_box_cnt ">
              Boost Your Business With Launchpad Development Company!
            </p>
            <button
              data-toggle="modal"
              data-target="#myModal"
              className="lnpd_box_btn "
            >
              Get Free Consultancy{" "}
              <span>
                <i className="fa-solid fa-arrow-right"></i>
              </span>
            </button>
          </div>
        </article>

        {/* features */}
        <article className="primary__landing-content-container">
          <div className="lnpd_feature lnpd_mb_100">
            <h3 className="lnpd_subtitle lnpd_fe_title">
              <span className="lnpd_span">Features we provide </span>
              in our Crypto Launchpad
            </h3>
            <p className="lnpd_subcontent lnpd_fe_cnt">
              We provide launchpads that are built with the proper features to
              deliver world-class performance
            </p>

            <div className="row g-4 lnpd_fe_row">
              {featureData.map((feature, index) => (
                <div className="col-lg-4 col-sm-6" key={index}>
                  <div className="lnpd_feature_card">
                    <div className="lnpd_feature_card_inner">
                      <img
                        src={feature.img}
                        alt="Crypto Launchpad Development Company"
                        loading="lazy"
                      />
                      <h5>{feature.title}</h5>
                      <p>{feature.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </article>

        {/* box */}
        <article className="primary__landing-content-container">
          <div className="lnpd_box lnpd_box_flx lnpd_mb_100">
            <p className="lnpd_box_cnt">
              Stream Into the Decentralized Market With Launchpad Development
              Company!!
            </p>
            <button
              data-toggle="modal"
              data-target="#myModal"
              className="lnpd_box_btn "
            >
              Ask Us How{" "}
              <span>
                <i className="fa-solid fa-arrow-right"></i>
              </span>
            </button>
          </div>
        </article>

        {/* why */}
        <article className="primary__landing-content-container">
          <div className="lnpd_why lnpd_mb_100">
            <h3 className="lnpd_subtitle lnpd_why_title">
              <span className="lnpd_span">Why Should </span>
              in our Crypto Launchpad
            </h3>
            <p className="lnpd_subcontent lnpd_why_cnt">
              Launchpad is one of the most effective ways to collect cash and
              raise awareness for innovative blockchain initiatives
            </p>

            <div className="row g-4 lnpd_why_row">
              {whyChooseData.map((item, index) => (
                <div className="col-xl-3 col-lg-4 col-sm-6" key={index}>
                  <div className="lnpd_why_card">
                    <div className="lnpd_why_card_inner">
                      <img
                        src={item.img}
                        alt="Crypto Launchpad Development Company"
                        loading="lazy"
                      />
                      <h5>{item.title}</h5>
                      <p>{item.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </article>

        {/* blockchains */}
        <article className="lnpd_blockchain lnpd_mb_100">
          <div className="primary__landing-content-container">
            <h3 className="lnpd_subtitle lnpd_bl_title">
              <span className="lnpd_span">White Label Crypto </span>
              Launchpad Development On Various Blockchains
            </h3>

            <div className="row">
              <div className="col-lg-4"></div>
            </div>

            <>
              <Swiper
                className="fd-step-swiper az-dev-swiper p-1"
                spaceBetween={30}
                slidesPerView={3}
                modules={[Navigation]}
                navigation={{
                  prevEl: ".lnpd_bl_prev",
                  nextEl: ".lnpd_bl_next",
                }}
                breakpoints={{
                  320: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                  },
                  480: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                  },
                  1025: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                  },
                  1200: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                  },
                }}
                onSlideChange={handleBlockChange}
                onReachBeginning={() => setIsPrevBlockDisabled(true)}
                onReachEnd={() => setIsNextBlockDisabled(true)}
                onFromEdge={() => {
                  setIsPrevBlockDisabled(false);
                  setIsNextBlockDisabled(false);
                }}
              >
                <SwiperSlide>
                  <div className="lnpd_bl_card">
                    <div className="lnpd_bl_card_inner">
                      <img
                        src={require("../../../image/Launchpad/bl_img_one.webp")}
                        alt="Crypto Launchpad Development Company"
                        loading="lazy"
                      />
                      <h5>Polkastarter Like Launchpad</h5>
                      <p>
                        Polkastarter, a protocol developed on top of the
                        Polkadot network, enables project token sales in a
                        secure and decentralised manner. It allows for
                        cross-chain token swaps and guards against market
                        manipulation
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="lnpd_bl_card">
                    <div className="lnpd_bl_card_inner">
                      <img
                        src={require("../../../image/Launchpad/bl_img_two.webp")}
                        alt="Crypto Launchpad Development Company"
                        loading="lazy"
                      />
                      <h5>Launchpad-like BSC Pad</h5>
                      <p>
                        The BSC Pad platform allows bitcoin projects to
                        distribute tokens and obtain funding. It is a
                        decentralised, equitable launch platform that aims to be
                        the next generation of blockchain launchpads
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="lnpd_bl_card">
                    <div className="lnpd_bl_card_inner">
                      <img
                        src={require("../../../image/Launchpad/bl_img_three.webp")}
                        alt="Crypto Launchpad Development Company"
                        loading="lazy"
                      />
                      <h5>Secure pad like Launchpad</h5>
                      <p>
                        Secure Pad is a new launch programme that invites new
                        ideas by bringing together developers and other
                        brilliant crypto industry professionals. Developers can
                        switch their attention from the concept to the finished
                        result
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="lnpd_bl_card">
                    <div className="lnpd_bl_card_inner">
                      <img
                        src={require("../../../image/Launchpad/bl_img_four.webp")}
                        alt="Crypto Launchpad Development Company"
                        loading="lazy"
                      />
                      <h5>Firestarter Like Launchpad</h5>
                      <p>
                        FireStarter is the first IMO (Initial Metaverse
                        Offering) launchpad on the Polygon network, supporting
                        DeFi, NFT, GameFi, and social token initiatives.
                        According to IMO, new enterprises rely on this launchpad
                        to raise capital
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="lnpd_bl_card">
                    <div className="lnpd_bl_card_inner">
                      <img
                        src={require("../../../image/Launchpad/bl_img_five.webp")}
                        alt="Crypto Launchpad Development Company"
                        loading="lazy"
                      />
                      <h5>Seedify Like Launchpad</h5>
                      <p>
                        Seedify is a blockchain innovation hub with a
                        DAO-powered seed-stage fund. It, like Kucoin and
                        Pancakeswap, is a decentralised incubator and launchpad
                        that supports the blockchain ecosystem's future projects
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="lnpd_bl_card">
                    <div className="lnpd_bl_card_inner">
                      <img
                        src={require("../../../image/Launchpad/bl_img_six.webp")}
                        alt="Crypto Launchpad Development Company"
                        loading="lazy"
                      />
                      <h5>Ethereum Like Launchpad</h5>
                      <p>
                        The Ethereum launchpad is a new platform for creating
                        your own money or token. The launchpad is powered by the
                        Ethereum blockchain, which uses smart contracts to
                        control the selling of your money or token
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="lnpd_bl_card">
                    <div className="lnpd_bl_card_inner">
                      <img
                        src={require("../../../image/Launchpad/bl_img_seven.webp")}
                        alt="Crypto Launchpad Development Company"
                        loading="lazy"
                      />
                      <h5>Trustswap Like Launchpad</h5>
                      <p>
                        TrustSwap, a decentralised protocol, and a launchpad are
                        built on the BSC network. Staking, Smart Locks, and
                        Smart Swaps are all uses for $SWAP, which allows tokens
                        to be wrapped inside an ERC20 token
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="lnpd_bl_card">
                    <div className="lnpd_bl_card_inner">
                      <img
                        src={require("../../../image/Launchpad/bl_img_eight.webp")}
                        alt="Crypto Launchpad Development Company"
                        loading="lazy"
                      />
                      <h5>Binance Like Launchpad</h5>
                      <p>
                        Binance is one of the most popular cryptocurrency
                        exchanges in the world, with its own launch programme
                        known as "Binance Launchpad." The launch platform
                        assists blockchain startups in raising financing
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>

              <div className="lnpd_bl_btn_wrap">
                <button
                  className={`lnpd_bl_prev ${
                    isPrevBlockDisabled ? "disabled" : ""
                  }`}
                  style={{
                    color: isPrevBlockDisabled ? "#00000094" : "#000",
                    cursor: isPrevBlockDisabled ? "not-allowed" : "pointer",
                  }}
                >
                  <i className="fa-solid fa-chevron-left"></i>
                </button>
                <button
                  className={`lnpd_bl_next ${
                    isNextBlockDisabled ? "disabled" : ""
                  }`}
                  style={{
                    color: isNextBlockDisabled ? "#00000094" : "#000",
                    cursor: isNextBlockDisabled ? "not-allowed" : "pointer",
                  }}
                >
                  <i className="fa-solid fa-chevron-right"></i>
                </button>
              </div>
            </>
          </div>
        </article>

        {/* process */}
        <article className="primary__landing-content-container">
          <div className="lnpd_process lnpd_mb_120">
            <div className="row g-4 ">
              <div className="col-lg-6">
                <h3 className="lnpd_subtitle staking-card-list">
                  <span className="lnpd_span">End-to-End Process </span>
                  in Development of Crypto Launchpad Platform
                </h3>
              </div>
              <div className="col-lg-6">
                <div className="lnpd_process_wrap staking-card-list">
                  {processData.map((item) => {
                    return (
                      <div key={item.id} className="lnpd_process_flx">
                        <h5>{item.title} </h5>
                        <p>{item.description}</p>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </article>

        {/* best */}
        <article className="primary__landing-content-container">
          <div className="lnpd_best lnpd_mb_120">
            <h3 className="lnpd_subtitle lnpd_bst_title">
              <span className="lnpd_span">What makes </span>
              us the Best Company for Developing Crypto Launchpads?
            </h3>
            <p className="lnpd_subcontent lnpd_bst_cnt">
              To deliver the right answers, the right people must be at the
              right place at the right time. Beleaf is the ideal location for
              Launchpad Development services, allowing us to provide optimal and
              stable Launchpad development solutions based on your needs. As the
              best Launchpad development firm, we have the following
              characteristics that set us apart from other Launchpad solution
              providers
            </p>

            <div className="row g-4 lnpd_bst_row">
              {bestFeatures.map((feature, index) => (
                <div className="col-lg-4 col-sm-6" key={index}>
                  <div className="lnpd_bst_card">
                    <img
                      src={feature.img}
                      alt="Crypto Launchpad Development Company"
                      loading="lazy"
                    />
                    <h6>{feature.title}</h6>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </article>

        {/* box */}
        <article className="primary__landing-content-container">
          <div className="lnpd_box_sp lnpd_mb_80">
            <div className="row g-4 w-100 lnpd_sp_row">
              <div className="col-lg-5">
                <div>
                  <p className="lnpd_box_cnt lnpd_sp_cnt">
                    Specify Your Preferences For Customization When Building
                    Your Launchpad!!
                  </p>

                  <button
                    data-toggle="modal"
                    data-target="#myModal"
                    className="lnpd_box_btn mt-4"
                  >
                    Hire Our Experts{" "}
                    <span>
                      <i className="fa-solid fa-arrow-right"></i>
                    </span>
                  </button>
                </div>
              </div>
              <div className="col-lg-7 text-center">
                <img
                  src="https://res.cloudinary.com/djcn5wxkj/image/upload/v1777114942/specify_bmcm50_1_1_ihnnuc.webp"
                  alt="Crypto Launchpad Development Company"
                  loading="lazy"
                  className="lnpd_sp_img"
                />
              </div>
            </div>
          </div>
        </article>
      </main>

      {/* faq */}
      <article className="primary__landing-content-container">
        <div className="landing-faq-wrapper">
          <div className="row">
            <div className="col-lg-6">
              <h6 className="landing-faq-left-title">
                Frequently Asked <span className="faq-span">Questions.</span>{" "}
                {""}
              </h6>
            </div>
            <div className="col-lg-6">
              <div>
                <div className="accordion" id="faq">
                  <div className="landing-faq-card">
                    <div className="landing-faq-header" id="faqhead1">
                      <button
                        className="landing-faq-title collapsed"
                        type="button"
                        data-toggle="collapse"
                        data-target="#faq1"
                        aria-expanded="true"
                        aria-controls="faq1"
                      >
                        I don't have any crypto tokens of my own. Can I still
                        build my crypto launchpad?
                      </button>
                    </div>

                    <div
                      id="faq1"
                      className="collapse"
                      aria-labelledby="faqhead1"
                      data-parent="#faq"
                    >
                      <div className="landing-faq-content">
                        Certainly! You do not need your own token to establish
                        your crypto launchpad.
                      </div>
                    </div>
                  </div>

                  <div className="landing-faq-card">
                    <div className="landing-faq-header" id="faqhead2">
                      <div
                        className="landing-faq-title collapsed"
                        data-toggle="collapse"
                        data-target="#faq2"
                        aria-expanded="true"
                        aria-controls="faq2"
                      >
                        What is the function of a crypto launchpad?
                      </div>
                    </div>

                    <div
                      id="faq2"
                      className="collapse"
                      aria-labelledby="faqhead2"
                      data-parent="#faq"
                    >
                      <div className="landing-faq-content">
                        IDO platforms, often known as crypto launchpads, are
                        essentially crowdfunding portals for blockchain-based
                        ventures. These, like crypto incubators, provide
                        platforms for minting new coins and crypto ventures, as
                        well as raising liquidity.
                      </div>
                    </div>
                  </div>

                  <div className="landing-faq-card">
                    <div className="landing-faq-header" id="faqhead3">
                      <div
                        className="landing-faq-title collapsed"
                        data-toggle="collapse"
                        data-target="#faq3"
                        aria-expanded="true"
                        aria-controls="faq3"
                      >
                        How do the launchpads function?
                      </div>
                    </div>

                    <div
                      id="faq3"
                      className="collapse"
                      aria-labelledby="faqhead3"
                      data-parent="#faq"
                    >
                      <div className="landing-faq-content">
                        The Launchpads are a decentralised platform where
                        businesses can publish their cryptocurrency ideas for
                        evaluation and verification before making them public.
                      </div>
                    </div>
                  </div>

                  <div className="landing-faq-card">
                    <div className="landing-faq-header" id="faqhead4">
                      <div
                        className="landing-faq-title collapsed"
                        data-toggle="collapse"
                        data-target="#faq4"
                        aria-expanded="true"
                        aria-controls="faq4"
                      >
                        Are Launchpads financially successful?
                      </div>
                    </div>

                    <div
                      id="faq4"
                      className="collapse"
                      aria-labelledby="faqhead4"
                      data-parent="#faq"
                    >
                      <div className="landing-faq-content">
                        Almost every initial coin offering (IEO) on the Binance
                        Launchpad has been profitable, with token sales selling
                        out in seconds.
                      </div>
                    </div>
                  </div>

                  <div className="landing-faq-card">
                    <div className="landing-faq-header" id="faqhead5">
                      <div
                        className="landing-faq-title collapsed"
                        data-toggle="collapse"
                        data-target="#faq5"
                        aria-expanded="true"
                        aria-controls="faq5"
                      >
                        How quickly can you construct the launchpad for me?
                      </div>
                    </div>

                    <div
                      id="faq5"
                      className="collapse"
                      aria-labelledby="faqhead5"
                      data-parent="#faq"
                    >
                      <div className="landing-faq-content">
                        Although the time it takes to construct a launchpad
                        varies depending on the scale of the project, we use our
                        experience and skills to shorten your time-to-market and
                        help you to quickly enter the market with a superb
                        product.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>

      <ServiceFooter />
    </>
  );
};

export default Launchpad;
